import axios from 'axios'
import user from './user'
import {handleError} from "../../common"

const state = {
    customers: []
};

const mutations = {
    setCustomers(state, customers) {
        state.customers = customers;
    },
    deleteCustomer(state, id){
        state.customers = state.customers.filter(obj => {
            return obj.id !== id
        });
    },
};

const getters = {
};

const actions = {

    loadCustomers({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
            params: params
        };
        return new Promise((resolve) => {
            axios.get('/api/user/customers', config )
                .then((response) => {
                    if (response.data.success) {
                        commit('setCustomers', Object.values(response.data.clients));
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    deleteCustomer({commit}, id) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve, reject) => {
            axios.post('/api/user/delete-customer', {id: id}, config)
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Customer deleted",
                            type: "success",
                        } , { root: true });
                        commit('deleteCustomer', id);
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    addCustomer({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve, reject) => {
            axios.put('/api/user/add-customer', params, config )
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Customer added",
                            type: "success",
                        } , { root: true });
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        reject();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    updateCustomer({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve) => {
            axios.put('/api/user/update-customer', params, config )
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Customer updated",
                            type: "success",
                        } , { root: true });
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
/*    saveSettings({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve) => {
            axios.post('/api/settings/save', params, config )
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Settings updated",
                            type: "success",
                        } , { root: true });
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    addType({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve) => {
            axios.put('/api/settings/add-type', params, config )
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Item added",
                            type: "success",
                        } , { root: true });
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    updateType({commit}, params) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve) => {
            axios.put('/api/settings/update-type', params, config )
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Item Updated",
                            type: "success",
                        } , { root: true });
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: response.data.message,
                            type: "error",
                        } , { root: true });
                        resolve();
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });
        });
    },
    deleteTerminalType({commit}, id) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve, reject) => {
            axios.post('/api/settings/delete-type', {id: id}, config)
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Terminal type deleted",
                            type: "success",
                        } , { root: true });
                        commit('deleteType', id);
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: "Delete Error",
                            type: "error",
                        } , { root: true });
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    },*/
};

export default {
    namespaced: true,
    actions,
    getters,
    state,
    mutations
}
